import Model, { attr, belongsTo, hasMany } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type Teacher from 'teacher-ui-client/models/teacher'
import type Student from 'teacher-ui-client/models/student'
import type Collection from 'teacher-ui-client/models/book-library/collection'
import { isBefore, isAfter } from 'date-fns'
import type DateTransform from 'teacher-ui-client/transforms/date'

export enum ShareStatus {
  Active = 'active',
  Expired = 'expired',
  Pending = 'pending',
}

export default class BookLibraryShare extends Model {
  @attr<DateTransform>('date') declare startsAt: Date

  @attr<DateTransform>('date') declare expiresAt: Date

  @belongsTo<Collection>('book-library/collection', { async: false, inverse: null }) declare collection: Collection

  @hasMany<Student>('student', { async: false, inverse: null }) declare students?: Student[]

  get sharedByUserId() {
    // @ts-expect-error - something wrong with relationship reference types
    return this.collection.belongsTo<Teacher, 'teacher'>('teacher').id()
  }

  get status() {
    const now = new Date()
    if (isBefore(now, this.startsAt)) return ShareStatus.Pending
    if (isAfter(now, this.expiresAt)) return ShareStatus.Expired
    return ShareStatus.Active
  }

  [Type] = 'book-library/share' as const
}
